/**
 * Files guide — how agents produce and work with files during runs.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { filesContent } from "@/constants/docs/files";

export const Route = createFileRoute("/docs/files")({
	component: FilesPage,
});

function FilesPage() {
	return <DocsPage title="Files" content={filesContent} />;
}
